module.exports = __webpack_public_path__ + "img/kq_question_creation.d78637cd.png";